import { z } from "zod";

import { RoomSystemVisibility } from "@classview/shared-types";

const sessionRoomSystemSchema = z.object({
  organisationId: z.string().min(1, { message: "Organisation is required" }),
  displayName: z.string().min(1, { message: "Display name is required" }),
  email: z
    .string({
      required_error: "Email is required",
    })
    .email({ message: "Email is invalid" }),
  visibility: z.nativeEnum(RoomSystemVisibility, {
    errorMap: () => ({ message: "Room system visibility is required" }),
  }),
});

type SessionRoomSystemFormData = z.infer<typeof sessionRoomSystemSchema>;

export { sessionRoomSystemSchema };
export type { SessionRoomSystemFormData };
